export default "Suramortissement Fiscal (Art. 39 CGI) — Déductibilité des équipements énergétiques | Solution Éco France";
